import { useState } from 'react';
import PhotosEditorModal from '../../../../components/PhotosEditorModal/PhotosEditorModal';

export default function PhotosPreview({
    listing,
    editMode = false,
    // PP-419 — receives the merged photos array from the modal's Save; the
    // parent stages them into dirtyFields.photos, and the drawer's Save
    // Changes PUTs everything atomically. See PropertyDrawer.stagePhotos.
    onStagePhotos,
}) {
    const [modalOpen, setModalOpen] = useState(false);

    const photos = (listing.photos || []).map((p, i) => ({
        ...p,
        label: `Photo ${i + 1}`,
        featured: p.featured || i === 0,
    }));

    const label = photos.length === 0
        ? 'None yet'
        : `${photos.length} uploaded`;

    return (
        <div className="host-panel-section">
            <div className="host-panel-section-header">
                <span className="host-panel-section-label">
                    <span className="host-panel-section-title">
                        <span>Photos</span>
                        <span className="section-aux">{label}</span>
                    </span>
                </span>
                {editMode && (
                    <button
                        type="button"
                        className="host-section-edit-link"
                        onClick={() => setModalOpen(true)}
                    >
                        Edit →
                    </button>
                )}
            </div>
            {photos.length > 0 ? (
                <div className="host-photo-grid">
                    {photos.map((photo, i) => (
                        <div key={photo.id || photo.url || i} className="host-photo">
                            {photo.url ? (
                                <img src={photo.url} alt={photo.label || `Photo ${i + 1}`} />
                            ) : (
                                photo.label || `Photo ${i + 1}`
                            )}
                            {photo.featured && (
                                <span className="host-photo-featured">Featured</span>
                            )}
                        </div>
                    ))}
                </div>
            ) : (
                <p className="drawer-empty-note">No photos uploaded yet</p>
            )}
            <PhotosEditorModal
                open={modalOpen}
                onClose={() => setModalOpen(false)}
                listing={listing}
                onStagePhotos={onStagePhotos}
            />
        </div>
    );
}
